import * as React from "react";
import { CheckPricesProps } from "./typings";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { Container } from "./component/Container";
import { Deal } from "./component/Deal";

const checkPricesKey = new ItemKeyHelper("check-prices");
// TODO the back-end should have control over what is being rendered as a deal. Right now it follows an anti-pattern of sending a whole bunch of data without proper hierarchy:
//  https://github.expedia.biz/Flex/check-prices-flex-module/blob/master/src/main/java/com/expedia/www/check/prices/module/CheckPricesFlexModuleResult.java
const supportedDeals = ["today", "tomorrow", "thisWeekend", "nextWeekend", "bestWeekend"];

export const viewContext = React.createContext<string>("");
const ViewProvider = viewContext.Provider;

export const CheckPrices = (props: CheckPricesProps) => {
  const { context, flexComponent, l10n } = props;
  const model = flexComponent.model;
  const availableSupportedDeals = supportedDeals.filter((deal) => deal in model);

  const containerProps = {
    title: model.title,
    id: flexComponent.id,
    fmId: flexComponent.fmId,
    fmTitleId: flexComponent.fmTitleId,
    view: model.view,
    subHeadline: model.subHeadline,
    dataType: model.dataType,
  };

  return (
    <ViewProvider value={model.view}>
      <Container {...containerProps}>
        {availableSupportedDeals.map((modelKey) => (
          <Deal key={checkPricesKey.next()} modelKey={modelKey} model={model} context={context} l10n={l10n} />
        ))}
      </Container>
    </ViewProvider>
  );
};

export default CheckPrices;
